<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} UPCOMING EVENT CONTENT</template>
		<template #body>

					<div class="form-floating mb-4">
						<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
						<label class="form-label" for="title">Title</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.location" id="location" name="location" class="form-control" placeholder="Location" />
						<label class="form-label" for="location">Location</label>
					</div>
					<div class="form-floating mb-4">
						<div class="mb-4">
							<label class="form-label" for="event_image">Event Image</label>
							<div class="fw-bold text-danger">Recommended Size: width:1150px height:648px</div>
							<input
								@change="onFileChange"
								type="file"
								id="event_image"
								name="event_image"
								class="form-control"
								:accept="[
					            'image/jpeg',
					            'image/jpg',
					            'image/png'
					          ]"
							/>
						</div>
						<div class="mb-4">
							<div v-if="form.prev_event_image!=null"
								class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
								style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
								:class="{'opacity-25':(form.event_image!=form.prev_event_image && form.prev_event_image!=null && action=='update')}"
							>
								<img :src="form.event_image_url" style="width:100%;" />
							</div>
							<div v-if="form.event_image!=form.prev_event_image && form.prev_event_image!=null && action=='update'" class="text-center text-muted">
								<i class="fa fa-arrow-down fa-2x"></i>
							</div>
							<div>
								<div id="image-preview"
									class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
									style="background-size: contain;background-repeat: no-repeat;background-position: center;"
									:style="{'height':(form.event_image!=form.prev_event_image)?'300px':'0px'}"
								>
									
								</div>
								<div v-if="form.event_image!=form.prev_event_image && form.prev_event_image!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
							</div>
						</div>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.event_link" id="event_link" name="event_link" class="form-control" placeholder="Event Link" />
						<label class="form-label" for="event_link">Event Link</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.info_link" id="info_link" name="info_link" class="form-control" placeholder="Info Link" />
						<label class="form-label" for="info_link">Info Link</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.event_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.event_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="event_datetime">DateTime</label>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_featured">Is feature?</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_featured"
									id="is_featured_on"
									name="is_featured"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_featured_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_featured"
									id="is_featured_off"
									name="is_featured"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_featured_off">OFF</label>
							</div>
						</div>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_active">Status</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_on"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_off"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_off">OFF</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Upcoming Event</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster';

export default {
	props: {
		
	},
	setup(props) {

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			upcoming_event_uuid : null,
			is_featured 		: 0,
			is_active 			: 1,
			title 				: null,
			location 			: null,
			event_image 		: null,
			prev_event_image 	: null,
			event_image_url 	: null,
			event_link 			: null,
			info_link 			: null,
			event_datetime 		: null,
		})

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#event_image").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.event_image = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.event_image = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.event_image = form.prev_event_image;
			clearUpload();
		}

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}
		}

		const addContent = () => {
			form.post(route('admin.post.upcoming-events'), {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['events','api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('upcoming-events/'+form.upcoming_event_uuid, {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['events','api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setUpcomingEventContent = (_action,data)=>{

								form.reset();

								if(_action=='update')
								{
									form.upcoming_event_uuid 	= data.upcoming_event_uuid;
									form.is_featured 			= data.is_featured;
									form.is_active 				= data.is_active;
									form.title 					= data.title;
									form.location 				= data.location;
									form.event_image 			= data.event_image;
									form.prev_event_image 		= data.prev_event_image;
									form.event_image_url 		= data.event_image_url;
									form.event_link 			= data.event_link;
									form.info_link 				= data.info_link;
									form.event_datetime 		= data.event_datetime;
								}
								
								action.value = _action;
							}


		return {
			toast,
			form,
			modal,
			toggleModal,
			clearUpload,
			onFileChange,
			removeUploadImage,
			action,
			setUpcomingEventContent,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
